import { Locale } from '@frontend/common';
import { getCorrectTranslation } from '@frontend/lang';
import { IProduct } from '@frontend/product/types';
import React from 'react';
import { LuCircleStop } from 'react-icons/lu';

export interface ProductRowProps {
    product: IProduct;
    depth: number;
    onProductClick: (product: IProduct) => void;
    locale: Locale | undefined;
    isLast?: boolean;
}

export const ProductRow: React.FC<ProductRowProps> = ({ product, depth, onProductClick, locale, isLast = false }) => {
    const indentLevel = depth * 50;
    const productName = getCorrectTranslation(locale, product, 'name');

    const handleProductNameClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onProductClick(product);
    };

    const infoParts: string[] = [];
    if (product.attributes) {
        Object.entries(product.attributes).forEach(([key, value]) => {
            infoParts.push(`${key}: ${value}`);
        });
    }

    return (
        <div className={`border-border-default hover:bg-background-surface-hover flex h-12 items-center ${isLast ? '' : 'border-b'}`}>
            <div
                className='flex w-full items-center gap-4 px-4'
                style={{ paddingLeft: `${16 + indentLevel}px` }}>
                <div className='flex size-5 shrink-0 items-center justify-center'></div>
                <div
                    className='hover:text-brand-primary flex w-full cursor-pointer items-center gap-2 font-medium'
                    onClick={handleProductNameClick}>
                    <LuCircleStop
                        className='text-foreground-muted shrink-0'
                        size={16}
                    />
                    <span>{productName}</span>
                    {infoParts.length > 0 && <span className='text-foreground-muted'>({infoParts.join(', ')})</span>}
                </div>
            </div>
        </div>
    );
};
